import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M10.9441 6.084a6.9 6.9 0 0 1 1.06-.08c3.18 0 6.17 2.29 7.91 6.0001a15.2 15.2 0 0 1-.9 1.64 1 1 0 0 0-.16.55 1 1 0 0 0 1.86.5 15.8 15.8 0 0 0 1.21-2.3 1 1 0 0 0 0-.79c-2.02-4.69-5.82-7.6-9.92-7.6a7.77 7.77 0 0 0-1.4.12 1.015 1.015 0 0 0-.6573.413 1.0143 1.0143 0 0 0 .9973 1.587zm-7.23-3.79a1.0041 1.0041 0 1 0-1.42 1.42l3.1 3.09a14.62 14.62 0 0 0-3.31 4.8001 1 1 0 0 0 0 .8c2.02 4.69 5.82 7.6 9.92 7.6a9.26 9.26 0 0 0 5.05-1.54l3.24 3.25a.9997.9997 0 0 0 1.42 0 .9997.9997 0 0 0 0-1.42zm6.36 9.1901 2.45 2.45a1.81 1.81 0 0 1-.52.07 2 2 0 0 1-2-2 1.8 1.8 0 0 1 .07-.52m1.93 6.52c-3.18 0-6.17-2.29-7.9-6a12.09 12.09 0 0 1 2.7-3.79l1.77 1.79a3.9999 3.9999 0 0 0 5.43 5.43l1.59 1.57a7.24 7.24 0 0 1-3.59 1"
}), "Hide", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
